import styles from "../aic.module.css";
import { AioLabel } from "./aioLabel";

interface AioSelectProps {
  id: string;
  label?: string;
  value: string;
  availableValues?: Array<string>;
  setValue?: (value: string) => void;
}

/**
 * Selection input component.
 *
 * @param props - AioSelectProps
 * @param props.id - The id for the select element
 * @param props.label - Optional label for the select
 * @param props.value - The current selected value
 * @param props.availableValues - Array of available string values to select from
 * @param props.setValue - Optional function to update the selected value
 */
export const AioSelect = (props: AioSelectProps): React.ReactElement => {
  return (
    <>
      <AioLabel
        id={`${props.id}-label`}
        label={props.label}
        htmlFor={props.id}
      />
      <div className={styles.aioInputHolder}>
        {!props.setValue ? (
          <span id={props.id}>{props.value}</span>
        ) : (
          <select
            id={props.id}
            className={styles.aioSelect}
            value={props.value}
            onChange={(e) => props.setValue!(e.currentTarget.value)}
          >
            {props.availableValues &&
              props.availableValues.map((v: string, i: number) => {
                return (
                  <option
                    key={i}
                    value={v}
                  >
                    {v}
                  </option>
                );
              })}
          </select>
        )}
      </div>
    </>
  );
};

AioSelect.displayName = "AioSelect";
